// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a30ab6c4f8dc641ab847","655":"8311f9a5a89241bdc99d"}[chunkId] + ".js";
};